import React, { useState } from 'react'
import AnnotatedText from './AnnotatedText'

import { withNamespaces } from 'react-i18next'
import ReactHtmlParser from 'react-html-parser'
import Skeleton from 'react-loading-skeleton'
import { checkText } from '../api/api'

const initialScore = {
  avalingua: {
    annotation: { explanation: undefined },
    lexicometrics: { tokens: undefined },
    score: {
      score_gram: undefined,
      score_lex: undefined,
      score_total: undefined,
    },
    statistics: {
      grammar_errors: undefined,
      lexical_errors: undefined,
      grammar_warnings: undefined,
      lexical_warnings: undefined,
    },
  },
}

const GrammarChecker = props => {
  const { t } = props
  const inputText = ''
  const [data, setData] = useState({
    text: inputText,
    language: 'gl',
  })

  const [error, setError] = useState(null)

  const [isLoading, setLoading] = useState(false)

  const [score, setScore] = useState({})

  const handleInputChange = event => {
    setData({
      ...data,
      [event.target.name]: event.target.value,
    })
  }

  const analyzeText = (text, language) => {
    setLoading(true)
    setError(null)
    checkText(text, language)
      .then(result => {
        setScore(result)
      })
      .catch(e => {
        setError(e.toString())
        //throw new Error(`Request failed. ${e}`)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleSubmit = event => {
    event.preventDefault()
    analyzeText(data.text, data.language)
  }

  if (score === initialScore) return <div>Loading...</div>

  return (
    <section id="second" className="main special">
      <header className="major">
        <h2>{t('Try our grammar checker')}</h2>
        <p>{t('Select your language and introduce your text.')}</p>
      </header>
      <form onSubmit={handleSubmit}>
        <div>
          <label>
            {/*Select language:*/}
            <select
              value={data.language}
              onChange={handleInputChange}
              name="language"
            >
              <option value="gl">{t('Galician')}</option>
              <option value="pt">{t('Portuguese')}</option>
              <option value="es">{t('Spanish')}</option>
            </select>
          </label>
          <textarea
            placeholder={t('Write or paste your text here')}
            className="form-control avalingua-input-text"
            onChange={handleInputChange}
            name="text"
            value={data.text}
          />
        </div>
        <input
          className="button special"
          type="submit"
          value={t('Submit')}
          disabled={!data.text}
        />
      </form>

      {error ? (
        <header className="error">
          <p>{error}</p>
        </header>
      ) : null}

      {isLoading ? (
        <Skeleton count={10} />
      ) : (
        <>
          <ul className="statistics">
            <li className="style1">
              <span className="icon fa-exclamation-circle" />
              <strong>
                {score.avalingua
                  ? score.avalingua.statistics.grammar_errors
                  : '0'}
              </strong>{' '}
              {t('Grammar errors')}
            </li>
            <li className="style2">
              <span className="icon fa-exclamation-circle" />
              <strong>
                {score.avalingua
                  ? score.avalingua.statistics.lexical_errors
                  : '0'}
              </strong>{' '}
              {t('Lexical errors')}
            </li>
            <li className="style1">
              <span className="icon fa-exclamation-triangle" />
              <strong>
                {score.avalingua
                  ? score.avalingua.statistics.grammar_warnings
                  : '0'}
              </strong>{' '}
              {t('Grammar warnings')}
            </li>
            <li className="style2">
              <span className="icon fa-exclamation-triangle" />
              <strong>
                {score.avalingua
                  ? score.avalingua.statistics.lexical_warnings
                  : '0'}
              </strong>
              {t('Lexical warnings')}
            </li>
          </ul>
          <ul className="statistics">
            <li className="style1">
              <span className="icon fa-signal" />
              <strong>
                {score?.avalingua?.score?.score_gram?.toFixed(2) || '0'}
              </strong>
              {t('Grammatical score')}
            </li>
            <li className="style2">
              <span className="icon fa-signal" />
              <strong>
                {score?.avalingua?.score?.score_lex?.toFixed(2) || '0'}
              </strong>
              {t('Lexical score')}
            </li>

            <li className="style3">
              <span className="icon  fa-calculator" />
              <strong>
                {score?.avalingua?.score?.score_total?.toFixed(2) || '0'}
              </strong>
              {t('Total score')}
            </li>
            <li className="style5">
              <span className="icon fa-folder-open-o" />
              <strong>
                {score?.avalingua?.lexicometrics?.tokens || '0'}
              </strong>{' '}
              {t('Words in the text')}
            </li>
          </ul>

          <header className="major">
            <p>{t('Annotated text.')}</p>
            <AnnotatedText
              text={score.avalingua ? score?.avalingua?.text?.trim() : null}
              annotations={score.avalingua ? score.avalingua.annotation : null}
            />
          </header>
          {score.avalingua && score.avalingua.annotation ? (
            <header className="major">
              <p>{t('Detailed error list')}</p>
              <div className="responsive-table-wrapper">
                <table className="annotations-table">
                  <thead>
                    <tr>
                      <th>{t('Word')}</th>
                      <th>{t('Suggestion')}</th>
                      <th>{t('Class')}</th>
                      <th>{t('Label')}</th>
                      <th>{t('Explanation')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {score?.avalingua?.annotation &&
                      score?.avalingua?.annotation?.map((annotation, index) => (
                        <tr key={index}>
                          <th>{annotation.word}</th>
                          <td>{annotation.suggestion}</td>
                          <td>{annotation.class}</td>
                          <td>{annotation.label}</td>
                          <td className="explanation">
                            {ReactHtmlParser(annotation.explanation)}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </header>
          ) : null}
        </>
      )}
    </section>
  )
}

export default withNamespaces()(GrammarChecker)
